<ion-header [hidden]="inApp" class="order-header">
    <ion-toolbar>
        <ion-buttons slot="start">
            <custom-back-button [overwriteTranslateKey]="'pages.cart.order-more'"
                                (backButtonClick)="backButtonClick()"></custom-back-button>
        </ion-buttons>
        <!-- <ion-title>{{"pages.cart.title" | translate}}
        </ion-title> -->
        <ion-buttons slot="primary" *ngIf="orderService.isCourt">
            <ion-button (click)="homeButtonClick()" class="back-btn">
                <ion-icon name="home"></ion-icon>
            </ion-button>
        </ion-buttons>
        <!-- the seats numbers display -->
        <ion-buttons slot="end" *ngIf="orderService.spot && !orderService.isCourt && orderService.seats > 0">
            <div class="seat-number-box">
                <ion-icon name="people"></ion-icon>
                {{orderService.seats}}
            </div>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>


    <div *ngIf="showPassCode && otp" class="custom-dialog-wrapper" (click)="$event.stopPropagation()" slot="fixed">

        <div class="custom-passcode-dialog animated fadeInUps">
            <ion-icon (click)="$event.stopPropagation();closeClicked()" class="close-icon" name="ios-close"></ion-icon>

            <div class="text-box">
                <p>{{"pages.splash.enterPasscode" | translate}}</p>
            </div>
            <div class="input-box">
                <ion-input #otpinput [(ngModel)]="passcode" autofocus maxlength="8" name="passcode" type="tel">
                </ion-input>
                <div class="error-text-box" ion-text>
                    <p *ngIf="wrong" class="animated fadeInUps">{{"pages.splash.errorPasscode" | translate}}</p>
                </div>
            </div>
            <div class="btn-box">
                <ion-button (click)="$event.stopPropagation();submit()" class="confirm-btn" class="confirm-btn"
                            fill="clear">{{"buttons.confirm" | translate}}</ion-button>
            </div>
        </div>
    </div>


    <!-- special feature box -->
    <section class="section-divider"
             *ngIf="getPickupDelayTime(orderManager.store) && getPickupDelayTime(orderManager.store) > 0">
        <div *ngIf="orderManager.mode != 'delivery'" class="deli-msg-text">
            {{"pages.cart.delivery-message" | translate}}
            <span class="mins-text">{{getPickupDelayTime(orderManager.store)}} {{"global.minutes" | translate}}
            </span>
        </div>

        <div *ngIf="orderManager.mode == 'delivery'" class="deli-msg-text">
            {{"pages.cart.delivery-message" | translate}}
            <span class="mins-text">{{getDeliveryDelayTime(orderManager.store)}} {{"global.minutes" | translate}}
            </span>
        </div>
    </section>

    <section class="section-divider">
        <!-- Order Information  -->
        <div *ngIf="orderService.isBK" class="order-info-box">
            <!-- Delivery Address -->
            <div (click)="editAddress()" *ngIf="orderManager.mode == 'delivery'"
                 [ngClass]="{'invalid-address': invalidAddress}" class="row-box address-box" tappable>
                <div class="col-left">
                    <ion-icon name="md-bicycle" color="brand-sub" slot="end"></ion-icon>
                    <p *ngIf="!invalidAddress">Address</p>
                    <p *ngIf="invalidAddress" class="flashit">Please enter address</p>
                </div>
                <div class="col-right" [ngClass]="{'invalid-address': invalidAddress}">
                    <button>
                        <p [ngClass]="{'flashit': invalidAddress}">{{getAddressString()}}</p>
                        <ion-icon name="md-create" color="success"></ion-icon>
                    </button>
                </div>
            </div>
            <!-- Reward-->
            <div *ngIf="offers.length > 0 && memberService.getMember()" class="row-box coupon-box">
                <button (click)="presentRewards()" *ngIf="!orderService.selectedReward "
                        class="before-selection animated fadeInUps">
                    <img src="../assets/images/gift.svg">
                    <p>My Rewards!</p>
                    <ion-icon name="md-arrow-dropdown" color="success"></ion-icon>
                </button>
                <div (click)="presentRewards()" *ngIf="orderService.selectedReward"
                     class="after-selection animated fadeInUps AQA-reward-item">
                    <ion-icon name="ios-checkmark-circle" color="success"></ion-icon>
                    <div class="txt-box">
                        <p>Selected Reward</p>
                        <p>{{orderService.selectedReward.reward.name}}</p>
                    </div>
                </div>

            </div>
            <!-- PickUp / Delivery Time -->
            <div *ngIf="settings.pickupTime && orderManager.mode != 'delivery' && orderManager.mode != 'dinein' && !orderService.spot" class="row-box time-box AQA-pickupTime">
                <div class="col-left">
                    <ion-icon name="aig-time" color="brand-sub" slot="end"></ion-icon>
                    <p>{{"pages.cart.pickUp-time" | translate}}</p>
                </div>
                <div class="col-right">
                    <button (click)="timeSelectAlert()">
                        <p>{{timelabel}}</p>
                        <!-- <ion-icon *ngIf="!orderService.isBK" name="aig-arrow-right" class="arrow-down" color="success"></ion-icon> -->
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="!orderService.isBK" class="order-info-box">

            <!-- Reward-->
            <div *ngIf="offers.length > 0 && memberService.getMember()" class="order-info-wrapper">
                <div *ngIf="!orderService.selectedReward" class="row-box coupon-box">
                    <button class="selection-box before-selection animated fadeInUps" (click)="presentRewards()">
                        <div class="reward-svg-box">
                            <div class="reward-svg-animation">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                     style="enable-background:new 0 0 21 21;" viewBox="0 0 21 21" xml:space="preserve">
                                    <g id="top">
                                        <path style="stroke-dasharray:45px, 45px; stroke-dashoffset: 90px;" class="st0"
                                              d="M9.3,4.7H7.1c-1,0-1.8-0.8-1.8-1.8c0-1.2,0.9-2,2.2-2c0.8,0,1.5,0.2,2.2,1.6l0.8,2l0.1,0.2l0.9-2.2
                                                        c0.7-1.5,1.4-1.6,2.2-1.6c1.2,0,2.2,0.7,2.2,2c0,1-0.8,1.8-1.8,1.8H9.3"/>
                                    </g>
                                    <g id="outline">
                                        <polyline class="st1" points="3.2,9.4 2.4,9.4 2.4,4.7 18.6,4.7 18.6,9.4 12.8,9.4 12.8,19.8 8.2,19.8 8.2,9.4 3.6,9.4 3.6,19.8
                                                        17.4,19.8 17.4,9.4 3.6,9.4 	"
                                                  style="stroke-dasharray:180px, 180px; stroke-dashoffset: 360px;"/>
                                    </g>
                                    <g id="colored">
                                        <rect class="st2" height="4.6" width="16.2" x="2.4" y="4.7"/>
                                        <rect class="st2" height="10.4" width="13.9" x="3.6" y="9.4"/>
                                        <rect class="st3" height="1.3" width="13.9" x="3.6" y="9.4"/>
                                        <rect class="st4" height="15" width="4.6" x="8.2" y="4.7"/>
                                    </g>
                                </svg>
                            </div>
                        </div>
                        <div class="txt-box">
                            <div class="item-name-txt-box">
                                <p>{{"pages.cart.selectReward" | translate}}</p>
                            </div>
                        </div>
                        <ion-icon name="md-arrow-dropdown" color="dark"></ion-icon>
                    </button>
                </div>

                <div *ngIf="orderService.selectedReward && orderService.selectedReward.orderitems"
                     class="after-selection-wrapper" tappable>
                    <!-- <ion-icon name="ios-checkmark-circle" color="success"></ion-icon> -->
                    <div class="row-box coupon-box">
                        <button class="selection-box after-selection">
                            <div class="reward-svg-box">
                                <div class="reward-svg-animation">
                                    <img src="../assets/images/gift_opened.svg">
                                </div>
                            </div>
                            <div class="txt-box">
                                <p class="title-text">{{"pages.cart.selectedReward" | translate}}</p>
                                <p>{{orderService.selectedReward.reward.name}}</p>
                                <!-- TODO: fill in selected item's title -->
                                <div *ngIf="orderService.selectedReward.orderitems[0]" class="item-name-txt-box">
                                    <p *ngFor="let oi of orderService.selectedReward.orderitems[0].items">{{oi.name}}
                                    </p>
                                </div>
                            </div>
                            <div *ngIf="orderService.selectedReward.orderitems[0]">
                                <p style="color: #222">
                                    {{orderManager?.store?.currencySign}}{{orderService.selectedReward.orderitems[0].total}}
                                </p>
                            </div>
                        </button>
                        <ion-button fill="outline" size="small" (click)="presentRewards()" class="edit-btn">
                            <p>{{"pages.cart.changeReward" | translate}}</p>
                        </ion-button>
                    </div>

                </div>
            </div>


            <!-- select point -->

            <ng-container *ngIf="points && points.length > 0 && !(points.length === 1 && points[0] === 0 ) && pointFeature">

                <ion-card class="cart-list-box" *ngIf="userTotalPoints && userTotalPoints > 0">
                    <div class="item-box">
                        <ion-card-header text-warp class="list-title-box" [ngClass]="{'is-alc':true}">
                            <p class="subset-qty-text">{{"pages.cart.total-points" | translate}}: </p>
                            <p class="price-text">
                                {{userTotalPoints}}</p>
                        </ion-card-header>
                    </div>
                </ion-card>

                <div class="user-point-box row-box" *ngIf="userTotalPoints >= order.grandTotal">

                    <ion-item class="point-selector-item" no-lines [ngClass]="{'has-point': selectedPoint > 0}">
                        <ion-label>
                            <span *ngIf="selectedPoint == 0">{{"pages.cart.redeem-points" | translate}}</span>
                            <span *ngIf="selectedPoint > 0">
                                <ion-icon name="checkmark-circle"></ion-icon>
                                {{"pages.cart.selected-points" | translate}}
                            </span>
                        </ion-label>
                        <ion-select [(ngModel)]="selectedPoint" (ionChange)="onPointSelectUpdate()">
                            <ion-select-option *ngFor="let p of points" [value]="p">{{p}}</ion-select-option>
                        </ion-select>
                    </ion-item>
                    <!-- <ion-row tappable class="row-wrapper" (click)="refreshAnimation();$event.stopPropagation()">
                        <ion-col size="6" class="icon-col">
                            <ion-icon name="{{isPointFullPay ? 'checkbox' : 'square-outline'}}"></ion-icon>
                        </ion-col>
                        <ion-col size="6" class="info-col">
                            <div class="point-info-box">
                                <p>Save with points</p>
                                <ng-container *ngIf="!isPointFullPay">
                                        <p>You can use up to {{userTotalPoints}} points to save $x</p>
                                </ng-container>
                                <ng-container *ngIf="isPointFullPay">
                                        <p>You have selected {{selectedPoint}} points to <span class="empha">save {{orderManager?.store?.currencySign}}{{selectedPoint}}</span></p>
                                </ng-container>
                            </div>
                        </ion-col>
                    </ion-row> -->

                </div>

                <div class="user-point-box row-box">
                    <ion-row (click)="refreshAnimation();$event.stopPropagation()" class="row-wrapper" tappable>
                        <ion-col class="icon-col" size="2">
                            <ion-icon name="{{isPayByPoint ? 'checkbox' : 'square-outline'}}"></ion-icon>
                        </ion-col>
                        <ion-col class="info-col" size="10">
                            <div class="point-info-box">
                                <p>{{"pages.cart.save-with-points" | translate}}</p>
                                <ng-container *ngIf="!isPayByPoint">
                                    <p>You can use up to {{points[points.length - 1]}} points to save
                                        ${{(points[points.length - 1] * orderManager.pointsFactor).toFixed(2)}}</p>
                                </ng-container>
                                <ng-container *ngIf="isPayByPoint">
                                    <p>You have selected {{selectedPoint}} points to <span
                                            class="empha">save ${{(selectedPoint * orderManager.pointsFactor).toFixed(2)}}</span>
                                    </p>
                                </ng-container>
                            </div>
                        </ion-col>
                    </ion-row>

                </div>
            </ng-container>
            <!-- promotional code -->
            <div *ngIf="orderManager?.store?.menu?.settings?.discountInput"
                 (click)="showPromoGift()" class="row-box promotional-code-box AQA-promoteCode">

                <ion-row class="row-wrapper">
                    <ion-col size="2" class="icon-col">
                        <ion-icon name="md-pricetag" color="success"></ion-icon>
                    </ion-col>

                    <ion-col size="10" class="info-col">
                        <ng-container *ngIf="!(orderService.promoCodeGift && orderService.promoCodeGift.length > 0)">
                            <ion-text color="success">{{"pages.cart.input-discount-code" | translate}}</ion-text>
                        </ng-container>

                        <ng-container *ngIf="orderService.promoCodeGift && orderService.promoCodeGift.length > 0">
                            <div class="gits">
                                <ng-container *ngFor="let gift of orderService.promoCodeGift">
                                    <ion-icon color="success" name="checkmark"></ion-icon>
                                    <p>{{gift.name}}</p>
                                </ng-container>
                            </div>
                        </ng-container>
                    </ion-col>
                </ion-row>
            </div>

            <!-- coupon code -->
            <div *ngIf="orderService.couponMap['canShowCouponInput'] && enableCoupon"
                 (click)="showCouponCode();$event.stopPropagation()"
                 class="row-box promotional-code-box AQA-couponCode">

                <ion-row class="row-wrapper">
                    <ion-col size="2" class="icon-col">
                        <ion-icon name="md-pricetag" color="success"></ion-icon>
                    </ion-col>

                    <ion-col size="10" class="info-col">
                        <ion-text color="success">{{"pages.cart.input-coupon-code" | translate}}</ion-text>
                    </ion-col>
                </ion-row>
            </div>
            <div *ngIf="orderService.couponMap['couponDisplay']" class="row-box coupon-box "
                 (click)="couponClicked();$event.stopPropagation()">

                <ion-row class="row-wrapper">
                    <ion-col size="2" class="icon-col">
                        <div *ngIf="orderService.couponMap['canUseCoupon'] && orderService.couponMap['useCoupon']">
                            <ion-icon name="md-checkmark-circle" color="success"></ion-icon>
                        </div>
                        <div *ngIf="!orderService.couponMap['useCoupon'] || !orderService.couponMap['canUseCoupon']">
                            <ion-icon name="md-information-circle" color="danger"></ion-icon>
                        </div>
                    </ion-col>
                    <ion-col size="10" class="info-col">
                        <div *ngIf="orderService.couponMap['couponBenefit']" class="coupon-title">
                            {{"pages.cart.benefit" | translate}} {{orderService.couponMap['couponBenefit']}}
                        </div>
                        <div *ngIf="orderService.couponMap['couponConds'] && orderService.couponMap['couponConds'].length > 0"
                             [ngClass]="{'success': orderService.couponMap['canUseCoupon'] && orderService.couponMap['useCoupon'],'no-use': !orderService.couponMap['useCoupon'],'locked': !orderService.couponMap['canUseCoupon'] && orderService.couponMap['useCoupon']}"
                             class="coupon-condition fadeInUps animated">
                            {{"pages.cart.condition" | translate}}
                            <ng-container *ngFor="let c of orderService.couponMap['couponConds']">
                                <span>{{c}} </span>
                                <span class="not-match-text">{{"pages.cart.not-match" | translate}}</span>
                            </ng-container>
                            <span class="not-in-use">{{"pages.cart.not-in-use" | translate}}</span>
                        </div>
                    </ion-col>
                </ion-row>
            </div>

            <!-- select pickup time -->
            <div *ngIf="settings.pickupTime && orderManager.mode != 'delivery' && orderManager.mode != 'dinein' && !orderService.spot"
                 class="row-box time-box order-info-wrapper">
                <ion-row class="row-wrapper">
                    <ion-col size="2" class="icon-col">
                        <ion-icon name="md-time"></ion-icon>
                    </ion-col>
                    <ion-col size="10" class="info-col">
                        <p>{{"pages.cart.pickUp-time" | translate}}</p>
                        <div class="keyButton-col">
                            <ion-button fill="outline" size="small" (click)="timeSelectAlert()">
                                <p>{{timelabel}}</p>
                            </ion-button>
                        </div>
                    </ion-col>
                </ion-row>
            </div>
            <!-- end select pickup time -->
        </div>
    </section>

    <!-- List Start -->
    <section class="section-divider">
        <div class="item-subhead-box">
            <p class="title-text seperate">{{"pages.cart.your-order" | translate}}</p>
            <!-- <ion-button fill="outline" size="small" (click)="editMode()" class="edit-btn">
                            <p [ngClass]="{'is-on' : editModeOn}">{{"pages.cart.edit-cap" | translate}}</p>
                            <p class="done-text" [ngClass]="{'is-on' : !editModeOn}">{{"pages.cart.done" | translate}}</p>
                        </ion-button> -->
        </div>
        <div class="ordered-item-box">

            <ion-card *ngFor="let oi of (orderManager?.order?.orderitems) ? orderManager.order.orderitems : [] "
                      class="cart-list-box">
                <div class="item-box">
                    <ion-card-header text-warp class="list-title-box" [ngClass]="{'is-alc':!isSet(oi)}">
                        <div *ngIf="getImage(oi.items[0])" class="item-img">
                            <img [src]="getImage(oi.items[0])">
                        </div>
                        <p class="title-text">{{oi.items[0].name}}</p>
                        <!-- <p class="subset-qty-text"> x{{oi.quantity}}</p> -->
                        <p *ngIf="settings && !settings.hidePrice" class="price-text itemPrice-text">
                            {{orderManager?.store?.currencySign}}
                            {{oi.items[0]|itemPrice: oi.quantity}}
                        </p>
                    </ion-card-header>

                    <!-- If this is a set item -->
                    <ion-list *ngIf="isSet(oi)" class="list-detail-box">
                        <ion-row *ngFor="let item of oi.items | slice:1" class="list-subset-box">
                            <ion-col class="subset-title-text" [ngClass]="{ismodifier: item.modifier}">
                                <p *ngIf="!item.modifier">+ {{item.name}}</p>
                                <p *ngIf="item.modifier">-
                                    {{getModifierItemDisplay(orderManager.store.menu.imap, item)}}</p>
                                <p class="subset-qty-text itemQty-text" *ngIf="item.quantity > 1"> x{{item.quantity}}
                                </p>
                            </ion-col>
                            <ion-col class="subset-price-text">
                                <p *ngIf="item.price > 0 && item.quantity > 0" class="itemPrice-text">
                                    +{{orderManager?.store?.currencySign}}
                                    {{item|itemPrice:oi.quantity}}
                                </p>
                            </ion-col>
                        </ion-row>

                    </ion-list>
                    <!-- If this is a modifier item -->
                    <ion-list *ngIf="!isSet(oi)" class="list-detail-box">
                        <ion-row *ngFor="let item of oi.items | slice:1" class="list-subset-box">
                            <ion-col class="subset-title-text">
                                <p *ngIf="item.modifier">-
                                    {{getModifierItemDisplay(orderManager.store.menu.imap, item)}} </p>
                                <p class="subset-qty-text itemQty-text" *ngIf="item.quantity > 1"> x{{item.quantity}}
                                </p>
                            </ion-col>
                            <ion-col class="subset-price-text">
                                <p *ngIf="item.price > 0 && item.quantity > 0" class="itemPrice-text">
                                    +{{orderManager?.store?.currencySign}}
                                    {{item|itemPrice:item.quantity}}                                </p>
                            </ion-col>
                        </ion-row>
                    </ion-list>
                </div>
                <div class="item-btn-box">
                    <!-- Normal edit box -->
                    <div class="edit-box">
                        <!-- for Set -->
                        <div *ngIf="isSet(oi) || oi.combo" class="set-box set-item">
                            <ul class="cart-item-panel">
                                <li class="btn-item-panel">
                                    <ion-button fill="clear" size="small" (click)="editClicked(oi)" color="medium">
                                        <ion-icon name="md-create"></ion-icon>
                                        <p>{{"pages.cart.edit" | translate}}</p>
                                    </ion-button>
                                </li>
                                <li class="btn-item-panel">
                                    <ion-button class="AQA-add-button" fill="clear" size="small"
                                                (click)="duplicateClicked(oi);" color="medium">
                                        <ion-icon name="md-copy"></ion-icon>
                                        <p>{{"pages.cart.add" | translate}}</p>
                                    </ion-button>
                                </li>
                                <li class="btn-item-panel">
                                    <ion-button class="AQA-minus-button" fill="clear" size="small"
                                                (click)="deleteClicked(oi)" color="medium">
                                        <ion-icon name="md-close"></ion-icon>
                                        <p>{{"pages.cart.delete" | translate}}</p>
                                    </ion-button>
                                </li>
                            </ul>
                        </div>

                        <!-- for A-la-carte -->
                        <div *ngIf="!isSet(oi) && !oi.combo" class="set-box">

                            <div class="cart-item-panel">
                                <div class="btn-item-panel btn-item-panel-set">
                                    <ion-button class="AQA-add-button" fill="clear" (click)="minusClicked(oi)"
                                                color="medium" size="small">
                                        <ion-icon slot="icon-only" name="remove"></ion-icon>
                                    </ion-button>
                                </div>
                                <div class="btn-item-panel btn-item-panel-set">
                                    <div class="subset-qty-text">
                                        <!-- <h3>{{"global.quantity"|translate}}: {{oi.quantity}}</h3> -->
                                        <p [attr.data-item-qty]="oi.quantity">{{oi.quantity}}</p>
                                    </div>
                                </div>
                                <div class="btn-item-panel btn-item-panel-set">
                                    <ion-button fill="clear" class="AQA-add-button" (click)="addClicked(oi)"
                                                color="success" size="small">
                                        <ion-icon slot="icon-only" name="add"></ion-icon>
                                    </ion-button>
                                </div>
                                <ng-container *ngIf="oi.modifiable">
                                    <div class="miyo-btn-box">
                                        <ion-button (click)="$event.stopPropagation();modifierClicked(oi)"
                                                    class="miyo-btn AQA-speReq-button" color="warning" fill="clear">
                                            <ion-icon slot="start" color="warning" src="./assets/icon/miyo.svg">
                                            </ion-icon>
                                            {{"pages.cart.special-request" | translate}}
                                        </ion-button>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                    </div>
                </div>
            </ion-card>

            <!-- gifts -->
            <ng-container *ngIf="orderService.seatsGift && orderService.seatsGift.length > 0">
                <div class="seats-title">
                    <p>{{"pages.cart.seats-gift" | translate}}</p>
                </div>
                <ion-card *ngFor="let gift of orderService.seatsGift" class="cart-list-box">
                    <div class="seats-gift">
                        <p>- {{gift.name}}</p>
                    </div>
                </ion-card>
            </ng-container>

            <ion-card *ngIf="orderManager.order && (orderManager.order.handling > 0)"
                      class="cart-list-box checkout-box">
                <div class="item-box">
                    <ion-card-header text-warp class="list-title-box">
                        <p *ngIf="!orderService.isBK" class="title-text">{{"global.pick-up-charge" | translate}}</p>
                        <p *ngIf="orderService.isBK" class="title-text">Delivery Charge</p>
                        <p class="price-text">
                            {{orderManager?.store?.currencySign}}{{orderManager.order.handling | number : '1.0-2'}}
                        </p>
                    </ion-card-header>
                    <!-- If this is a set item -->
                </div>
            </ion-card>


            <ion-card *ngIf="orderManager.mode === 'dinein' || orderManager.mode === 'takeaway'"
                      class="cart-list-box checkout-box">
                <div class="item-box">
                    <ion-card-header text-warp class="list-title-box">
                        <p class="title-text">{{"pages.cart.subtotal" | translate}}</p>
                        <p class="price-text AQA-subTotal" [attr.data-order-subtotal]="orderManager.order.total">
                            {{orderManager?.store?.currencySign}}{{orderManager.order.total | number : '1.0-2'}}</p>
                    </ion-card-header>

                    <ion-card-header text-warp class="list-title-box"
                                     *ngIf="orderManager.order.tax && settings && !settings.hidePrice">
                        <p class="title-text">{{"pages.cart.tax" | translate}}</p>
                        <p class="price-text AQA-subTotal" [attr.data-order-tax]="orderManager.order.tax">
                            {{orderManager?.store?.currencySign}}{{orderManager.order.tax | number : '1.0-2'}}</p>
                    </ion-card-header>

                    <ion-list *ngIf="orderManager.order.discount > 0" text-warp class="list-title-box">
                        <div>
                            <p *ngFor="let d of orderManager.order.discounts" [hidden]="!d.amount || d.amount <= 0">
                                {{d.name}}</p>
                        </div>
                        <p [attr.data-order-discount]="orderManager.order.discount" class="AQA-discount">
                            -{{orderManager?.store?.currencySign}}{{orderManager.order.discount | number : '1.0-2'}}</p>
                    </ion-list>

                    <ion-list *ngIf="orderManager.order.usedPoints > 0" text-warp class="list-title-box">
                        <div>
                            <p>{{"pages.cart.point" | translate}}</p>
                        </div>
                        <p [attr.data-order-point]="orderManager.order.usedPoints" class="AQA-discount">
                            -{{orderManager?.store?.currencySign}}{{orderManager.order.usedPoints * orderManager.pointsFactor| number : '1.0-2'}}</p>
                    </ion-list>

                    <ion-card-header text-warp class="list-title-box total-box">

                        <p class="title-text">{{"pages.cart.total" | translate}}</p>
                        <p class="price-text AQA-Total" [attr.data-order-total]="orderManager.getNetAmount()">
                            {{orderManager?.store?.currencySign}}{{orderManager.getNetAmount() | number : '1.0-2'}}
                        </p>

                    </ion-card-header>
                    <ion-card-header text-warp class="list-title-box point-box"
                                     *ngIf="pointFeature && memberService.getMember() && pointEarned > 0">
                        <p class="title-text">
                            {{"pages.cart.will-earn"|translate}}
                            <span>{{pointEarned | number : '1.0-2'}}</span>{{"pages.cart.points"|translate}}
                            .
                            <br>
                            {{"pages.cart.point-instant-update"|translate}}
                        </p>
                    </ion-card-header>
                </div>
            </ion-card>

            <!-- total price after applyDiscount - duplicated-->
            <!-- <ion-card *ngIf="orderManager.order?.discount > 0" class="cart-list-box">
                
                <div class="item-box">
                    <ion-card-header text-warp class="list-title-box">
                        <p class="title-text">{{"pages.cart.subtotal" | translate}}</p>
                        <p class="price-text">{{orderManager?.store?.currencySign}}{{orderManager.order.total | number : '1.0-2'}}</p>
                    </ion-card-header>

                    <ion-list text-warp class="list-title-box">
                        <ng-container *ngIf="orderManager.order?.discounts?.length > 0">                            
                            <div>                            
                                <ng-container *ngFor="let d of orderManager.order.discounts">                      
                                    <ng-container *ngIf="d.amount && d.amount > 0">       
                                        <p>
                                            {{d.name}}
                                        </p>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </ng-container>

                        <p>-{{orderManager?.store?.currencySign}}{{orderManager.order.discount | number : '1.0-2'}}</p>
                    </ion-list>

                    <ion-card-header text-warp class="list-title-box total-box">

                        <p class="title-text">{{"pages.cart.total" | translate}}</p>
                        <p class="price-text">{{orderManager?.store?.currencySign}}{{orderManager.order.grandTotal | number : '1.0-2'}}</p>
                    </ion-card-header>
                </div>
            </ion-card> -->
        </div>
        <div *ngIf="cartService.enable">
            <!-- Sharing Cart -->
            <!-- Edit Others Cart is not allowed -->
            <div class="item-subhead-box">
                <p class="title-text">Others order</p>

            </div>

            <ng-container *ngFor="let order2 of cartService.getOthersCart()">
                <img src={{order2?.avatar}}>
                <ion-card *ngFor="let oi of order2['orderitems']" class="cart-list-box">
                    <div class="item-box">
                        <ion-card-header [ngClass]="{'is-alc':!isSet(oi)}" class="list-title-box" text-warp>
                            <p class="title-text">{{oi.items[0].name}}</p>
                            <p class="subset-qty-text"> x{{oi.quantity}}</p>
                            <p *ngIf="settings && !settings.hidePrice" class="price-text">
                                {{oi.items[0]|itemPrice: oi.quantity}}
                            </p>
                        </ion-card-header>

                        <!-- If this is a set item -->
                        <ion-list *ngIf="isSet(oi)" class="list-detail-box">
                            <ion-row *ngFor="let item of oi.items | slice:1" class="list-subset-box">
                                <ion-col [ngClass]="{ismodifier: item.modifier}" class="subset-title-text">
                                    <p *ngIf="!item.modifier">+ {{item.name}}</p>
                                    <p *ngIf="item.modifier">-
                                        {{getModifierItemDisplay(orderManager.store.menu.imap, item)}}</p>
                                    <p *ngIf="item.quantity > 1" class="subset-qty-text itemQty-text">
                                        x{{item.quantity}}</p>
                                </ion-col>
                                <ion-col class="subset-price-text itemPrice-text">
                                    <p *ngIf="item.price > 0 && item.quantity > 0">
                                        +{{orderManager?.store?.currencySign}}
                                        {{item|itemPrice: item.quantity}}
                                    </p>
                                </ion-col>
                            </ion-row>

                        </ion-list>
                        <!-- If this is a modifier item -->
                        <ion-list *ngIf="!isSet(oi)" class="list-detail-box">
                            <ion-row *ngFor="let item of oi.items | slice:1" class="list-subset-box">
                                <ion-col class="subset-title-text">
                                    <p *ngIf="item.modifier">-
                                        {{getModifierItemDisplay(orderManager.store.menu.imap, item)}} </p>
                                    <p *ngIf="item.quantity > 1" class="subset-qty-text itemQty-text">
                                        x{{item.quantity}}</p>
                                </ion-col>
                                <ion-col class="subset-price-text itemPrice-text">
                                    <p *ngIf="item.price > 0 && item.quantity > 0">
                                        +{{orderManager?.store?.currencySign}}
                                        {{ item |itemPrice: item.quantity}}
                                    </p>
                                </ion-col>
                            </ion-row>
                        </ion-list>
                    </div>
                </ion-card>
            </ng-container>

        </div>
    </section>

    <!-- Upsell -->
    <section class="section-divider" *ngIf="hasRecommendation">
        <p class="title-text seperate">{{"pages.cart.up-selling-message" | translate}}</p>
        <div class="upSell-wrapper">
            <ng-container *ngFor="let upSellItem of upSellItems">
                <ng-container
                        *ngIf="!(inventoryManager.isHidden(upSellItem) || inventoryManager.isSoldout(upSellItem))">
                    <div class="usi-card AQA-add-button AQA-upsell-item" (click)="selectUpSelling(upSellItem)">
                        <div class="usi-card-inner cardShadow">
                            <div class="avatar-img-box">
                                <img *ngIf="upSellItem?.getImage('default',360,true)"
                                     src="{{upSellItem.getImage('default',360,true)}}">
                            </div>
                            <div class="info-box">
                                <p class="name-text">{{upSellItem?.name}}</p>
                                <p class="price-text itemPrice-text">{{orderManager?.store?.currencySign}}
                                    {{upSellItem|itemPrice}}
                                </p>
                            </div>
                            <div class="btn-box">
                                <ion-icon color="success" name="add-circle-outline"></ion-icon>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>

        </div>
    </section>


</ion-content>


<ion-footer>

    <div class="sub-footer clear-footer">
        <div class="ft-info-box" *ngIf="orderManager.store.menu.taxIncluded">
            <!-- <p>{{"pages.cart.selected-1" | translate}}{{orderManager.count}} {{"pages.cart.selected-2" | translate}}</p> -->
            <!-- <p *ngIf="settings && !settings.hidePrice">{{orderManager?.store?.currencySign}}{{orderManager.order.grandTotal | number : '1.0-2'}} -->
            <p>{{"pages.cart.tax-included" | translate}}</p>
        </div>

        <div class="ft-info-box" *ngIf="orderService.chargeDesc">
            <p class="hint-text" ion-text color="light-text" [innerHTML]="orderService.chargeDesc"></p>
            <!-- {{orderService.chargeDesc}} -->
        </div>
        <!-- END -->

        <ion-toolbar no-padding class="btn-box" color="contrast">
            <div class="ft-btn-box flashit">
                <ion-button (click)="orderClicked()" *ngIf="!orderService.preOrder"
                            class="key-btn-box AQA-key-button AQA-placeOrder-button" color="success" expand="block">
                    <ion-chip class="item-count-chip">
                        <ion-label>{{orderManager.count}}</ion-label>
                    </ion-chip>
                    <p class="checkout-text">{{"pages.cart.send-order" | translate}} <span
                            *ngIf="!orderService.hideTotal && !systemConfigService.hidePriceItemGridCart">-
                        {{orderManager?.store?.currencySign}}{{orderManager.getNetAmount() | number : '1.0-2'}}</span>
                    </p>
                    <ion-icon slot="end" name="arrow-forward"></ion-icon>
                </ion-button>
                <ion-button *ngIf="orderService.preOrder" expand="block" (click)="orderClicked()" class="key-btn-box">
                    <ion-chip [ngClass]="{'animated popped' : isBounce}" class="item-count-chip">
                        <ion-label>{{orderManager.count}}</ion-label>
                    </ion-chip>
                    <div class="btn-txt-tag">
                        <ion-icon name="md-star"></ion-icon>
                        <p>{{"pages.cart.save-order" | translate}}</p>
                    </div>
                    <div class="btn-price-tag">
                        <span>{{orderManager?.store?.currencySign}}{{orderManager.getNetAmount() | number : '1.0-2'}}</span>
                    </div>
                </ion-button>
            </div>
            <!-- <div class="btn-txt-tag">
                <p>{{"pages.cart.send-order" | translate}}</p>
                <ion-icon name="aig-arrow-right"></ion-icon>
            </div>
            <div class="btn-price-tag">
                <span *ngIf="settings && !settings.hidePrice">{{orderManager?.store?.currencySign}}{{orderManager.order.grandTotal + orderManager.getOfferItemPriceSafe() | number : '1.0-2'}}</span>
            </div> -->

        </ion-toolbar>


    </div>

</ion-footer>
